import { useTranslation } from 'react-i18next';
import SimpleSelectFilter from '../../../../../../../components/simple-select-filter';

const FilterNightsQuantities = ({ data }) => {
  const { t } = useTranslation('translations');

  return (
    <SimpleSelectFilter
      data={data}
      mapOptionRender={(nightsQuantity) => (
        <option key={nightsQuantity} value={nightsQuantity}>
          {`${nightsQuantity} ${t('filters.nightW')}`}
        </option>
      )}
      name='nightsQuantity'
    />
  );
};

export default FilterNightsQuantities;
